import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
export function ProductOverview() {
  const tomos = [{
    emoji: '🟠',
    title: 'TOMO 1',
    level: 'El ADN de la Masa',
    content: 'La base de todo. Acá no hay secretos. Masa base paso a paso explicada para principiantes absolutas.',
    image: 'https://cdn.magicpatterns.com/uploads/tRdQUjYACniv3c4y7qh9yQ/hf_20260421_223212_0d3b5dec-cbf2-4304-b819-5b91462370a3.png'
  }, {
    emoji: '🟡',
    title: 'TOMO 2',
    level: 'Master de Glaseados, Colores y Toppings',
    content: 'Las minidonas que la gente no puede dejar de fotografiar. Glaseados paso a paso: básico, chocolate, ganache, espejo.',
    image: 'https://cdn.magicpatterns.com/uploads/qtQLCYSZjgY3ECAvsJ41u3/hf_20260421_224110_34d18f3d-abdb-4963-83ad-3e0261fcd4b3.png'
  }, {
    emoji: '🟢',
    title: 'TOMO 3',
    level: 'Minidonas Saladas: El Sabor Argento',
    content: 'La clave para diferenciarte de la competencia. Ideales para eventos y picadas donde todos llevan lo mismo. ¡Sé la primera en ofrecerlas!',
    image: 'https://cdn.magicpatterns.com/uploads/ukkTZTA8FXkcKvi5mGx8BY/tomo_3_donas.png',
    highlight: true,
    badge: 'EL DIFERENCIAL'
  }, {
    emoji: '🔵',
    title: 'TOMO 4',
    level: 'Minidonas Fritas',
    content: 'Las que más se venden en ferias y eventos. La versión irresistible. Masa levada paso a paso con sus tiempos exactos.',
    image: 'https://cdn.magicpatterns.com/uploads/2krH6go81kULM1NzdNodAz/TOMO_4.png'
  }, {
    emoji: '🟣',
    title: 'TOMO 5',
    level: 'Packaging y Presentación',
    content: 'Porque la primera venta entra por los ojos. Tipos de cajas y materiales de packaging disponibles en Argentina.',
    image: 'https://cdn.magicpatterns.com/uploads/7CptmvbJAhaMxUYiWfmbro/TOMO_5.png'
  }, {
    emoji: '🔴',
    title: 'TOMO 6',
    level: 'Tu Negocio en Pesos',
    content: 'No pierdas plata. Te enseñamos a calcular el costo real en pesos argentinos hoy y cómo usar WhatsApp para que los pedidos lleguen solos.',
    image: 'https://cdn.magicpatterns.com/uploads/8sTv2nR2yzUbeAwmdGgFa2/TOMO_6.png'
  }];
  const includes = ['Recetas y técnicas listas para aplicar', 'Explicaciones paso a paso aptas para principiantes', 'Tablas, checklists y registros descargables', 'Adaptado al contexto argentino (ingredientes, precios, proveedores)', 'Lenguaje claro y directo — sin términos de pastelería profesional'];
  return <section className="w-full bg-[#F7F2EA] bg-texture py-16 md:py-24" data-id="element-206">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-208">
          <div className="text-center mb-16" data-id="element-209">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-[#3E2B1F] mb-4" data-id="element-210">
              MEGA PACK EMPRENDE MINIDONAS 360
            </h2>
            <p className="text-xl md:text-2xl text-[#B66A2C] font-medium mb-4" data-id="element-211">
              6 Tomos + 4 Bonos — Masa → Negocio en Pesos
            </p>
            <p className="text-xl md:text-2xl font-serif font-bold text-[#3E2B1F]/80" data-id="element-212">
              Todo resuelto. Paso a paso. Desde cero.
            </p>
          </div>

          <div className="mb-16" data-id="element-213">
            <h3 className="font-serif text-3xl md:text-4xl font-bold text-[#3E2B1F] mb-10 text-center" data-id="element-214">
              LOS 6 TOMOS COMPLETOS
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-215">
              {tomos.map((tomo, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              duration: 0.6
            }} className={`rounded-2xl p-8 relative overflow-hidden transition-all duration-300 ${tomo.highlight ? 'bg-white border-2 border-[#B66A2C] shadow-premium hover:shadow-premium-hover' : 'bg-white border border-[#E7DDD2] shadow-sm hover:shadow-premium'}`} data-id="element-216">
                  {tomo.highlight && tomo.badge && <div className="inline-block bg-[#B66A2C] text-white text-xs font-bold tracking-widest px-3 py-1.5 rounded-full mb-4 uppercase" data-id="element-217">
                      {tomo.badge}
                    </div>}
                  {tomo.image && <div className="absolute top-6 right-6 w-16 h-20" style={{
                perspective: '500px'
              }} data-id="element-218">
                      <div className="relative w-full h-full rounded shadow-md" style={{
                  transform: 'rotateY(-15deg)',
                  transformStyle: 'preserve-3d'
                }} data-id="element-219">
                        <img src={tomo.image} alt="" className="w-full h-full object-cover rounded" data-id="element-220" />
                        <div className="absolute top-0 left-0 w-[4px] h-full bg-gradient-to-r from-[#E7DDD2] to-[#F7F2EA] rounded-l" data-id="element-221" />
                        <div className="absolute inset-0 rounded bg-gradient-to-r from-black/5 via-transparent to-transparent pointer-events-none" data-id="element-222" />
                      </div>
                    </div>}
                  <div className="text-4xl mb-4" data-id="element-223">{tomo.emoji}</div>
                  <h4 className={`font-serif text-2xl font-bold text-[#3E2B1F] mb-2 ${tomo.image ? 'pr-20' : ''}`} data-id="element-224">
                    {tomo.title}
                  </h4>
                  <p className="text-[#B66A2C] font-medium mb-4 text-sm md:text-base" data-id="element-225">
                    {tomo.level}
                  </p>
                  <p className="text-[#3E2B1F]/80 text-base leading-relaxed" data-id="element-226">
                    {tomo.content}
                  </p>
                </motion.div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-white border border-[#E7DDD2] rounded-2xl p-8 md:p-12 shadow-premium max-w-4xl mx-auto" data-id="element-227">
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#3E2B1F] mb-8 text-center" data-id="element-228">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-229">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-230">
                  <CheckCircleIcon className="w-6 h-6 text-[#B66A2C] flex-shrink-0" data-id="element-231" />
                  <p className="text-[#3E2B1F]/90 text-lg font-medium" data-id="element-232">
                    {item}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}